var ActionTypes;
(function (ActionTypes) {
  ActionTypes["fixed"] = "fixed";
  ActionTypes["crop"] = "crop";
  ActionTypes["min"] = "min";
  ActionTypes["max"] = "max";
})(ActionTypes || (ActionTypes = {}));

var UsageType;
(function (UsageType) {
  UsageType[UsageType["all"] = 0] = "all";
  UsageType[UsageType["commercial"] = 1] = "commercial";
})(UsageType || (UsageType = {}));
var ExperimentId;
(function (ExperimentId) {
  ExperimentId["hideNewModal"] = "0";
  ExperimentId["showNewModal"] = "1";
})(ExperimentId || (ExperimentId = {}));
var USER_SUBSCRIPTION_TYPES;
(function (USER_SUBSCRIPTION_TYPES) {
  USER_SUBSCRIPTION_TYPES["free"] = "free";
  USER_SUBSCRIPTION_TYPES["gold"] = "gold_old";
  USER_SUBSCRIPTION_TYPES["pro"] = "pro";
  USER_SUBSCRIPTION_TYPES["plus"] = "plus";
  USER_SUBSCRIPTION_TYPES["canceled"] = "canceled";
  USER_SUBSCRIPTION_TYPES["expired"] = "expired";
  USER_SUBSCRIPTION_TYPES["maxStarter"] = "max_starter";
  USER_SUBSCRIPTION_TYPES["maxPerformance"] = "max_performance";
})(USER_SUBSCRIPTION_TYPES || (USER_SUBSCRIPTION_TYPES = {}));
var LanguagesCodes;
(function (LanguagesCodes) {
  LanguagesCodes[LanguagesCodes["en"] = 0] = "en";
  LanguagesCodes[LanguagesCodes["zh"] = 1] = "zh";
  LanguagesCodes[LanguagesCodes["zh_HANT"] = 2] = "zh_HANT";
  LanguagesCodes[LanguagesCodes["fr"] = 3] = "fr";
  LanguagesCodes[LanguagesCodes["de"] = 4] = "de";
  LanguagesCodes[LanguagesCodes["hi"] = 5] = "hi";
  LanguagesCodes[LanguagesCodes["id"] = 6] = "id";
  LanguagesCodes[LanguagesCodes["it"] = 7] = "it";
  LanguagesCodes[LanguagesCodes["ko"] = 8] = "ko";
  LanguagesCodes[LanguagesCodes["pl"] = 9] = "pl";
  LanguagesCodes[LanguagesCodes["pt"] = 10] = "pt";
  LanguagesCodes[LanguagesCodes["ru"] = 11] = "ru";
  LanguagesCodes[LanguagesCodes["ja"] = 12] = "ja";
  LanguagesCodes[LanguagesCodes["es"] = 13] = "es";
  LanguagesCodes[LanguagesCodes["th"] = 14] = "th";
  LanguagesCodes[LanguagesCodes["tr"] = 15] = "tr";
  LanguagesCodes[LanguagesCodes["vi"] = 16] = "vi";
})(LanguagesCodes || (LanguagesCodes = {}));

export { ActionTypes as A, ExperimentId as E, LanguagesCodes as L, USER_SUBSCRIPTION_TYPES as U, UsageType as a };
//# sourceMappingURL=general-9698471b.js.map
